module.exports = __webpack_public_path__ + "img/about-1.1293d4cd.jpg";